/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Page Tariffs And Services Styled
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { TABLE_FOOTER_BOTTOM_STYLE } from '../../../../components/Table/constants';
import { ONBOARDING_DATA_ATTR } from '../../../../modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '../../../../modules/onboarding/types/onboardingTypes';
import { colors } from '../../../../theme';

export const PageTariffsAndServicesStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .error-page {
        padding-top: 32px;
        margin-bottom: 64px;
    }
`;

export const PageTariffsAndServicesBodyStyled = styled.div`
    display: flex;
    flex-direction: row;

    align-content: stretch;

    flex: 1 0 auto;
    position: relative;
`;

export const PageTariffsAndServicesSideStyled = styled.div`
    min-width: 285px;
    flex-basis: 285px;

    border-left: 1px solid ${colors.tariffsAndServicesSideBordersColor};
    border-right: 1px solid ${colors.tariffsAndServicesSideBordersColor};

    margin-bottom: -64px;
`;

export const PageTariffsAndServicesContentStyled = styled.div.attrs({
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.productCardList,
})`
    position: relative;
    flex: 1 0 auto;

    padding-left: 28px;
    margin-bottom: ${TABLE_FOOTER_BOTTOM_STYLE}px;
`;

export const PageTariffsAndServicesFooterFixedContainer = styled.div`
    position: fixed;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 64px;
    bottom: 32px;
    pointer-events: none;
`;

export const PageTariffsAndServicesFooterStickyContainer = styled.div`
    position: sticky;
    width: 100%;
    bottom: ${TABLE_FOOTER_BOTTOM_STYLE}px;
    pointer-events: none;
`;

/**
 * Полоска тени по краям
 */
export const PageTariffsAndServicesShadowStub = styled.div`
    position: relative;
    height: 64px;

    &:before {
        background: ${colors.tableFooterBgColor};
        content: '';
        position: absolute;
        left: 100%;
        top: -1px;
        height: 1px;
        box-shadow: 0px -3px 3px rgba(0, 0, 0, 0.16);
        width: 100vw;
    }
`;

export const PageTariffsAndServicesFooterStyled = styled.div`
    height: 64px;
    pointer-events: auto;
    position: relative;
    margin-left: 285px;
    margin-right: -40px;
    padding: 14px 40px 14px 28px;
    background: ${colors.tableFooterBgColor};
    display: flex;
    flex-direction: row;
    justify-content: space-between; // ie11 not-supported
    align-items: center;

    > div {
        flex: 1 0 auto;

        &:last-child {
            text-align: right;
        }
    }

    button[data-button="buttonBack"] {
        padding-left: 32px;
        padding-right: 32px;
    }

    &:before {
        background: ${colors.tableFooterBgColor};
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 1px;
        box-shadow: 0px -3px 3px rgba(0, 0, 0, 0.16);
    }
`;
